import { defineMessages } from 'react-intl';

/** The copy of "Where you can post yourself" (design outreach r1), the read-only community list. */
export const communityMessages = defineMessages({
  title: { id: 'app.outreach.community.title', defaultMessage: 'Where you can post yourself' },
  intro: {
    id: 'app.outreach.community.intro',
    defaultMessage:
      'Subreddits and forums that fit your sound, where you may share your own music — if you follow each community’s rules. We never post or message for you, and these are not part of a campaign.',
  },
  crumb: { id: 'app.outreach.community.crumb', defaultMessage: 'Community spots' },

  bannerTitle: {
    id: 'app.outreach.community.banner.title',
    defaultMessage: 'These are reference spots, not email contacts.',
  },
  bannerBody: {
    id: 'app.outreach.community.banner.body',
    defaultMessage:
      'A community has no submission email. Open it on Reddit and post following its rules and its self-promo thread or day. Breaking a subreddit’s rules can get you banned.',
  },

  colCommunity: { id: 'app.outreach.community.col.community', defaultMessage: 'Community' },
  colMembers: { id: 'app.outreach.community.col.members', defaultMessage: 'Members' },
  colRules: { id: 'app.outreach.community.col.rules', defaultMessage: 'Posting rules' },
  colSelfPromo: { id: 'app.outreach.community.col.selfPromo', defaultMessage: 'Self-promo' },

  membersLabel: { id: 'app.outreach.community.membersLabel', defaultMessage: 'members' },

  promoOk: { id: 'app.outreach.community.promo.ok', defaultMessage: 'Self-promo OK' },
  promoThread: { id: 'app.outreach.community.promo.thread', defaultMessage: 'Promo thread' },
  promoNo: { id: 'app.outreach.community.promo.no', defaultMessage: 'No self-promo' },

  open: { id: 'app.outreach.community.open', defaultMessage: 'Open {name} on Reddit' },

  empty: { id: 'app.outreach.community.empty', defaultMessage: 'No communities fit your sound yet.' },
  emptyBody: {
    id: 'app.outreach.community.emptyBody',
    defaultMessage: 'Plug looks again after each change of your sound. When a subreddit fits, it shows here.',
  },

  footer: {
    id: 'app.outreach.community.footer',
    defaultMessage:
      '{count, plural, one {# community fits your sound} other {# communities fit your sound}} · sorted by members',
  },
});
